import { createAction, props } from '@ngrx/store'
import { ParamsConfigModel } from './params-config.model'

const PullParamsConfig = createAction('[ParamsConfig] Pull')
const PullParamsConfigByName = createAction('[ParamsConfig] Pull By Name', props<{ name: string }>())
const ReplaceParamsConfig = createAction('[ParamsConfig] Replace', props<{ payload: Partial<ParamsConfigModel> }>())

export const ParamsConfigAction = {
  PullParamsConfig,
  PullParamsConfigByName,
  ReplaceParamsConfig
}
